var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-pane-wrapper h-auto", attrs: { id: "note-tab" } },
    [
      _c(
        "form",
        {
          staticClass: "h-100 d-flex flex-column align-items-end",
          attrs: { id: "note-form", autocomplete: "off" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "form-group-material form-group-wide no-validation-icons",
            },
            [
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "foreColorPicker" } },
                [_vm._v("Color Picker")]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "backColorPicker" } },
                [_vm._v("Color Picker")]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "note-field" } },
                [_vm._v(_vm._s(_vm.$t("client-profile.actions.addNote")))]
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "start-typing-id" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("client-profile.messages.startTypingToLeaveNote")
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note,
                    expression: "note",
                  },
                ],
                ref: "noteField",
                staticClass: "form-control required text-primary",
                attrs: { id: "note-field", type: "text", name: "note" },
                domProps: { value: _vm.note },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.note = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown" }, [
            _c("div", {
              ref: "addTipTooltip",
              staticClass: "time-bomb-tooltip",
              attrs: {
                title: "",
                "data-original-title": _vm.$t(
                  "client-profile.messages.doubleClickToAdd"
                ),
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "submitNote",
                staticClass:
                  "btn btn-primary clickable btn-sm submit-changes note",
                class: { "dropdown-toggle": !_vm.external },
                attrs: {
                  "data-toggle": _vm.external ? null : "dropdown",
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  disabled: !_vm.canSave,
                },
                on: {
                  dblclick: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("client-profile.actions.addNote")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.external
              ? _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "dropdownMenuLink" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item clickable",
                        attrs: { id: "dropdownMenuLink" },
                        on: {
                          click: function ($event) {
                            return _vm.handleAddNote(false)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("client-profile.actions.addNote")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item clickable",
                        on: {
                          click: function ($event) {
                            return _vm.handleAddNote(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("client-profile.actions.addNote")) +
                            " +\n          " +
                            _vm._s(_vm.$tc("global.words.activity", 1)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }